import { render, staticRenderFns } from "./InventoryOverview.vue?vue&type=template&id=74703624&scoped=true&"
import script from "./InventoryOverview.vue?vue&type=script&lang=js&"
export * from "./InventoryOverview.vue?vue&type=script&lang=js&"
import style0 from "./InventoryOverview.vue?vue&type=style&index=0&id=74703624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74703624",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74703624')) {
      api.createRecord('74703624', component.options)
    } else {
      api.reload('74703624', component.options)
    }
    module.hot.accept("./InventoryOverview.vue?vue&type=template&id=74703624&scoped=true&", function () {
      api.rerender('74703624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inventory/InventoryOverview.vue"
export default component.exports